module.exports = __webpack_public_path__ + "img/qr.3b6e66eb.jpg";